export default __webpack_public_path__ + "static/media/icono-supervisor.93d9931f.png";